import React from 'react';

function Investment() {
  return (
    <div className="investment-container">
      <h1>Investment Management</h1>
      <div className="investment-content">
        {/* Add your investment management content here */}
      </div>
    </div>
  );
}

export default Investment;
